export default "__VITE_ASSET__CzFBt0am__";